<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
      ref="topFilter"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[900px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reestr_fines_super_text1"] }}
          </label>
          <BaseInputNew
            class="tw-w-[200px]"
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            placeholder=""
            style="width: 100%; flex: 1"
            @input="fillFilter"
            :additionalParams="{ type: 'like' }"
            inputName="vehicle_fines__bill_id"
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reestr_fines_super_text2"] }}
          </label>
          <BaseInputNew
            class="tw-w-[200px]"
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            placeholder=""
            style="width: 100%; flex: 1"
            @input="fillFilter"
            :additionalParams="{ type: 'like' }"
            inputName="vehicle_fines__bill_id"
            inputRef="clients__phone"
            inputMask="a000aa000"
            maxLength="9"
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reestr_fines_super_text3"] }}
          </label>
          <BaseInputNew
            class="tw-w-[200px]"
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            placeholder=""
            style="width: 100%"
            @input="fillFilter"
            :additionalParams="{ type: 'like' }"
            inputName="vehicle_fines__bill_id"
          />
        </div>

        <div class="tw-flex tw-flex-row">
          <button type="button" class="tw-app-btn-primary" @click="loadData()">
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <div
      class="tw-px-[26px] tw-mt-[15px] tw-flex tw-items-center tw-justify-end tw-gap-[10px]"
    >
      <button
        class="tw-app-btn-primary tw-app-btn-primary-outline"
        @click="
          () => {
            activeSelectRowsMultiple = [];
            payInOneClick();
          }
        "
      >
        {{ dataLang["reestr_fines_super_text5"] }}
      </button>
      <button
        class="tw-app-btn-primary tw-app-btn-primary-outline"
        @click="checkAcceptCheckbox('payInOneClick')"
      >
        {{ dataLang["reestr_fines_super_text6"] }}
      </button>
    </div>

    <div class="tw-px-[26px] tw-mt-[15px] tw-flex tw-justify-between">
      <div class="tw-flex">
        <button @click="loadData(1)" class="tw-app-btn-primary-outline">
          {{ dataLang["register_btn_filter_on"] }}
        </button>
        <button
          @click="resetFilter"
          class="tw-app-btn-light !tw-text-[#0056AF]"
        >
          Сбросить
        </button>
      </div>
      <TwBasePagination
        :page-count="numPages"
        :pagination-params="{
          ...paginationFinesStateParams,
          limit: limitPaginationValue,
        }"
        :showLimitInput="true"
        @updateLimitValue="updateLimitValue"
        :page-range="10"
        :margin-pages="0"
        :click-handler="loadData"
      >
      </TwBasePagination>
    </div>

    <div
      class="tw-relative tw-px-[26px] tw-mt-[15px]"
      style="min-height: 250px"
    >
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div style="min-height: 400px">
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="vehicle_fines_super__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          v-if="!localLoading"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
            selectedRowKeys: activeSelectRowsMultiple,
          }"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="acceptDelete"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDelete')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang.confirm_dialog_delete }}
          </div>

          <!-- <div class="tw-h-[10px]"></div> -->

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptDelete')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Да
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="withoutOptionsModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="320"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('withoutOptionsModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text_error2"] }}
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('withoutOptionsModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text72"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="oneClickModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
      @beforeClose="() => (lastBillNumber = '')"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('oneClickModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_text449"] }}
          </div>

          <div class="tw-mb-[15px]" v-html="transformTextTranslateComputed"></div>

          <div class="tw-mb-[15px]">
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder="Начальный номер платежного поручения"
              @input="(data) => (lastBillNumber = data.value)"
              :additionalParams="{ type: 'like' }"
              inputName="lastBillNumber"
              type="number"
              inputType="number"
            >
            </BaseInputNew>
          </div>

          <div v-html="dataLang['reestr_fines_text448']"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('oneClickModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="payOneClickSend"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_super_text229"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptFine"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
      @beforeClose="() => (lastBillNumber = '')"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptFine')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reestr_fines_super_text24"] }}
          </div>

          <div v-html="dataLang['reestr_fines_super_text25']"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptFine')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_super_text26"] }}
            </button>
            <button
              @click="acceptFineSend"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reestr_fines_super_text27"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";

export default {
  components: {
    VeTable,
  },

  data() {
    return {
      limitPaginationValue: 50,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [
        { field: "vehicle_fines_statuses__id", value: "2", operator: "!=" },
      ],
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      nameValue: "",
      settingOneClick: {},
      activePagePagination: {},
      currentId: null,
      localLoadingModal: false,
      pincode: "",
      copiedDataForFilter: [],
      galleryExeples: null,
      transformTextTranslateComputed: "",
      lastBillNumber: "",
      selectsDataForModal: {
        places: [],
      },
      selectsFromModal: {
        places: [],
      },
      selectsData: {
        discount: [],
        statuses: [],
        clients: [],
        type: [],
      },
      selectsFilter: { discount: [], statuses: [], clients: [] },
      gelleryList: [],
      eventCustomOption: {},
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "vehicle_fines_statuses__name") {
            return row.settings?.vehicle_fines_statuses__name;
          }
          if (column.field == "vehicle_fines_super__last_bill_date") {
            return row.settings?.vehicle_fines_super__last_bill_date;
          }
          if (column.field == "vehicle_fines_super__gis_discount_uptodate") {
            return row.settings?.vehicle_fines_super__gis_discount_uptodate;
          }
        },
      },
    };
  },
  methods: {
    checkAcceptCheckbox(name) {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show(name);
        switch (name) {
          case "payInOneClick":
            this.payInOneClick();
            break;
        }
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    payOneClickSend() {
      if (this.lastBillNumber.length) {
        GeneralService.editOrCreate(`/fines-super/pay/txt`, {
          lastBillNumber: this.lastBillNumber,
          ids: this.activeSelectRowsMultiple,
        })
          .then((data) => {
            const filename = new Date().toISOString();
            const a = document.createElement("a");
            a.href = `data:text/plain;charset=utf-8,${encodeURIComponent(
              data.data
            )}`;
            a.download = `${filename}.txt`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            this.$modal.hide("payInOneClick");
            this.$modal.hide("oneClickModal");
            this.loadData();
            this.$modal.show("acceptFine");
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.$modal.hide("cancelFinesModal");
            this.localLoading = false;
          });
      } else {
        this.$toast.error(this.dataLang["reestr_fines_text450"], {
          duration: 5000,
        });
      }
    },
    cancelFines() {
      GeneralService.editOrCreate(`/fines/cancel`, {
        finesIds: this.activeSelectRowsMultiple,
      })
        .then((data) => {
          this.$toast.success(data.data.data.message);
          this.loadData();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.$modal.hide("cancelFinesModal");
          this.localLoading = false;
        });
    },
    payInOneClick() {
      GeneralService.editOrCreate(`/fines-super/pay/modal`, {
        ids: this.activeSelectRowsMultiple,
      })
        .then((data) => {
          this.$modal.show("oneClickModal");
          this.transformTextTranslateComputed = this.computedTranslate(
            data.data.data,
            this.dataLang["reestr_fines_text4"]
          );
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });

      return tranaslateLocal;
    },
    acceptFineSend() {
      GeneralService.editOrCreate(`/fines-super/pay/confirm`, {})
        .then((data) => {
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.$modal.hide("acceptFine");
        });
    },
    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [
        { field: "vehicle_fines_statuses__id", value: "2", operator: "!=" },
      ];
      this.selectsFilter.discount = [
        {
          label: this.dataLang.reestr_fines_text777,
        },
      ];
      this.selectsFilter.type = [
        {
          label: this.dataLang.reestr_fines_text777,
        },
      ];
      this.selectsFilter.statuses = [];
      this.loadData();
    },

    // On click
    // Navigate to: "Авторизация / Данные введены";
    // Animate: Smart animate;
    // Spring: { mass: 1, stiffness: 400, damping: 30 };

    closemodal() {
      this.currentId = null;
      this.updatedValues = {};
      this.activeSelectRowsMultiple = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    deleteRow(nameModal) {
      GeneralService.delete(`/objects/` + this.activeSelectRowsMultiple, {
        ...(this.pincode && { pincode: this.pincode }),
      })
        .then((data) => {
          this.loadData();

          this.$toast.success(data.data.message);
          this.$modal.hide("acceptDeleteWithPin");
          this.$modal.hide("acceptDelete");
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.$modal.show("acceptDeleteWithPin");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          } else if (e.response.status == 400) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/selects/field/filter_fines_table_select_discount`)
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.selectsData.discount = this.prepareLabelsForDefaultSelects(
              data.data.data.rows,
              "allSelects",
              true
            ).filter_fines_table_select_discount;
          })
          .catch((e) => {}),
        GeneralService.get(
          `/clients?joins=company,statistics,verifications,comment`
        )
          .then((data) => {
            this.selectsData.clients = data.data.data.rows;
          })
          .catch((e) => {}),

        // /fines/table/main?fields=vehicle_fines_statuses__id,vehicle_fines_statuses__name&uniqueBy=vehicle_fines_statuses__id
      ]).then(() => {
        GeneralService.get(`fines-super/table/main`, {
          params: {
            ...this.paginationFinesStateParams,
            page: page,
            limit: this.limitPaginationValue,
            ...(this.filter.length && { where: JSON.stringify(this.filter) }),
          },
        })
          .then((data) => {
            this.getFinesAll(data.data.data);

            this.dataTable = data.data.data.rows;
            this.localLoading = false;
          })
          .catch((e) => {
            this.localLoading = false;
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    // fillFilter(data) {
    //   let newValueFilter =
    //     data.type == 'like' ? `;percent;${data.value};percent;` : data.value
    //   if (!this.filter.find((x) => x.field == data.name)) {
    //     this.filter.push({
    //       field: data.name,
    //       value: newValueFilter,
    //       ...(data.type == 'like' && { operator: 'like' }),
    //       ...(data.operator && { operator: data.operator })
    //     })
    //   } else {
    //     this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
    //       newValueFilter
    //
    //   }
    //
    // },

    fillFilter(data) {
      this.topFilterParams = [];
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
        if (data.operator) {
          this.filter[
            this.filter.findIndex((x) => x.field == data.name)
          ].operator = data.operator;
        }
      }
    },

    openCard(datas) {
      let API_PATH = "";
      switch (process.env.VUE_APP_MODE_BUILD) {
        case "production":
          API_PATH = `https://api.crmrent.com`;
          break;
        case "testing":
          API_PATH = `https://api.crmtest.ru`;
          break;
        case "development":
          API_PATH = `http://api.sirius.development`;
          break;
        case "serve-hmr":
          API_PATH = `http://api.sirius.development`;
          break;
      }

      window
        .open(
          `${API_PATH}/fines-super/card/${
            datas.vehicle_fines_super__id
          }?employee-token=${encodeURI(
            JSON.parse(localStorage.getItem("user-token"))
          )}`,
          "_blank"
        )
        .focus();
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    // {field:"vehicle_fines_super__status_id", value:"2", operator:"!="}
    this.selectsFilter.discount = [
      {
        label: this.dataLang.reestr_fines_text777,
      },
    ];
    this.selectsFilter.type = [
      {
        label: this.dataLang.reestr_fines_text777,
      },
    ];
  },
  created() {
    Promise.all([
      //   }),
    ]).then(() => {
      this.loadData();
    });
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),
    columns() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          title: this.dataLang["reestr_fines_super_text7"],
          children: [
            {
              field: "vehicle_fines_super__created_at",
              key: "1723",
              title: this.dataLang["reestr_fines_super_text10"],
              align: "center",
              width: "8%",
              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__created_at
                      ? this.$time(row.vehicle_fines_super__created_at).format(
                          `${this.userSetting.company__tempalte_date} HH:mm`
                        )
                      : ""}
                  </span>
                );
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 25px"}></div>
                  </div>
                );
              },
            },
            {
              field: "vehicle_fines_super__company_order_id",
              key: "163",
              title: this.dataLang["reestr_fines_super_text11"],
              align: "center",
              width: "7%",
              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputRef={"clients__phFEone"}
                      inputName={"vehicle_fines_super__employee_id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "employees__name",
              key: "1533",
              title: this.dataLang["reestr_fines_super_text12"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"employees__name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "employees__phone",
              key: "172",
              title: this.dataLang["reestr_fines_super_text13"],
              align: "center",
              width: "10%",
              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },

              // renderBodyCell: ({ row, column, rowIndex }, h) => {
              //   return this.dataLang[row.vehicle_types__code]
              // },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 25px"}></div>
                  </div>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["reestr_fines_super_text8"],
          children: [
            {
              field: "vehicle_fines_super__type",
              key: "13746",
              title: this.dataLang["reestr_fines_super_text14"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.type}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "vehicle_fines_super__type"
                          )
                        ) {
                          if (e.value) {
                            this.filter.push({
                              field: "vehicle_fines_super__type",
                              value: e.value,
                            });
                          }
                        } else {
                          if (e.value) {
                            this.filter[
                              this.filter.findIndex(
                                (x) => x.field == "vehicle_fines_super__type"
                              )
                            ].value = e.value;
                          } else {
                            if (
                              !!this.filter.find(
                                (x) => x.field == "vehicle_fines_super__type"
                              )
                            ) {
                              this.filter.splice(
                                this.filter.findIndex(
                                  (x) => x.field == "vehicle_fines_super__type"
                                ),
                                1
                              );
                            }
                          }
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"ads__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={[
                        {
                          label: this.dataLang["reestr_fines_super_text29"],
                          value: "vehicle_fines_super_type_fine",
                        },
                        {
                          label: this.dataLang["reestr_fines_super_text28"],
                          value: "vehicle_fines_super_type_road",
                        },
                        {
                          label: this.dataLang.reestr_fines_text777,
                          value: false,
                        },
                      ]}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__type ==
                    "vehicle_fines_super_type_fine"
                      ? this.dataLang["reestr_fines_super_text29"]
                      : this.dataLang["reestr_fines_super_text28"]}
                  </span>
                );
              },
            },
            {
              field: "vehicles__gosnumber",
              key: "16531",
              title: this.dataLang["reestr_fines_super_text15"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },

              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputRef={"clients__phFEon2e"}
                      inputName={"vehicles__gosnumber"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "vehicle_fines_super__bill_id",
              key: "163111",
              title: this.dataLang["reestr_fines_super_text16"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputRef={"clients__phFEon2e"}
                      inputName={"vehicle_fines_super__bill_id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__bill_id
                      ? row.vehicle_fines_super__bill_id
                      : row.vehicle_fines_super__travel_id}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines_super__pay_bill_date",
              key: "16315",
              title: this.dataLang["reestr_fines_super_text17"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 25px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__pay_bill_date
                      ? this.$time(row.vehicle_fines_super__pay_bill_date)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines_super__offense_date_time",
              key: "12631",
              title: this.dataLang["reestr_fines_super_text18"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 25px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__offense_date_time
                      ? this.$time(row.vehicle_fines_super__offense_date_time)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(
                            `${this.userSetting.company__tempalte_date} HH:mm`
                          )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines_super__pay_bill_amount",
              key: "16311",
              title: this.dataLang["reestr_fines_super_text19"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 25px"}></div>
                  </div>
                );
              },
            },
            {
              field: "vehicle_fines_super__gis_discount_uptodate",
              key: "16331",
              title: this.dataLang["reestr_fines_super_text20"],
              align: "center",
              width: "7%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.discount}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) =>
                              x.field ==
                              "vehicle_fines_super__gis_discount_uptodate"
                          )
                        ) {
                          if (e.value) {
                            this.filter.push({
                              field:
                                "vehicle_fines_super__gis_discount_uptodate",
                              value: "0000-00-00",
                              operator: e.operator,
                              mod: "discountFine",
                            });
                          }
                        } else {
                          if (e.value) {
                            this.filter[
                              this.filter.findIndex(
                                (x) =>
                                  x.field ==
                                  "vehicle_fines_super__gis_discount_uptodate"
                              )
                            ].operator = e.operator;
                          } else {
                            if (
                              !!this.filter.find(
                                (x) =>
                                  x.field ==
                                  "vehicle_fines_super__gis_discount_uptodate"
                              )
                            ) {
                              this.filter.splice(
                                this.filter.findIndex(
                                  (x) =>
                                    x.field ==
                                    "vehicle_fines_super__gis_discount_uptodate"
                                ),
                                1
                              );
                            }
                          }
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"ads__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={[
                        {
                          label: this.dataLang["reestr_fines_text70"],
                          value: true,
                          operator: ">=",
                        },
                        {
                          label: this.dataLang["reestr_fines_text71"],
                          value: true,
                          operator: "<=",
                        },
                        {
                          label: this.dataLang.reestr_fines_text777,
                          value: false,
                        },
                      ]}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__gis_discount_uptodate
                      ? this.$time(
                          row.vehicle_fines_super__gis_discount_uptodate
                        ).format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicle_fines_super__last_bill_date",
              key: "16431",
              title: this.dataLang["reestr_fines_super_text21"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: false,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 25px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_fines_super__last_bill_date
                      ? this.$time(
                          row.vehicle_fines_super__last_bill_date
                        ).format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
          ],
        },
        {
          key: "8123",
          title: this.dataLang["reestr_fines_text30"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <img
                onClick={() => {
                  this.openCard(row);
                }}
                style={"cursor: pointer"}
                src={require(`@/assets/icons/card.svg`)}
              />
            );
          },
        },
        {
          field: "vehicle_fines_statuses__name",
          key: "9123",
          title: this.dataLang["reestr_fines_text31"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.statuses}
                  onInput={(e, w) => {
                    this.fillFilter({
                      name: "vehicle_fines_statuses__id",
                      value: e.value,
                      operator: e.operator,
                    });
                  }}
                  style={"width: 100px"}
                  label={"label"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={[
                    {
                      label: this.dataLang["fine_status_nopayed"],
                      value: 1,
                      operator: "=",
                    },
                    {
                      label: this.dataLang["fine_status_payed"],
                      value: 2,
                      operator: "=",
                    },
                    {
                      label: this.dataLang["fine_status_processing"],
                      value: 3,
                      operator: "=",
                    },
                    {
                      label: this.dataLang["fine_status_canceling"],
                      value: 4,
                      operator: "=",
                    },
                  ]}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>{this.dataLang[row.vehicle_fines_statuses__name]}</span>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.indicator {
  display: flex;
  padding: 5px 0;
  border-radius: 5px;
  background-color: #23b14d;
  color: white;
  width: 80px;
  font-size: 11px;
  display: flex;
  justify-content: center;

  &--warn {
    background-color: #ff3a20;
  }
}
</style>
